export default __webpack_public_path__ + "static/media/Proyecto Residencial Coinca II.71a328de.mp4";